import React, { useEffect, useState } from 'react';
import { BrandLogo } from '../components/brand/BrandLogo';
import { SoiDaoRoomCard } from '../components/soi-dao/SoiDaoRoomCard';
import { soiDaoService } from '../services/soiDaoService';

const POLL_MS = 3000;

export function SoiDaoOverviewPage() {
  const [rooms, setRooms] = useState([]);

  useEffect(() => {
    const load = () => {
      soiDaoService.getOverview().then(setRooms).catch(() => {});
    };
    load();
    const timer = setInterval(load, POLL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="space-y-6">
      <section className="rounded-2xl border border-red-100 bg-gradient-to-br from-white via-red-50/30 to-brand-gold-light/20 p-6 text-center shadow-sm">
        <BrandLogo size="lg" className="mx-auto mb-3" />
        <h2 className="text-2xl font-bold text-brand-red">สอยดาว Mungkorn</h2>
        <p className="mt-2 text-sm text-gray-600">
          เลือกห้อง · เลือกดาวบนกระดาน 00–99 · เปิดเลขลุ้นรางวัลทันที
        </p>
      </section>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {rooms.map((room) => (
          <SoiDaoRoomCard key={room.id} room={room} />
        ))}
      </div>

      <details className="rounded-xl border border-gray-200 bg-white p-4 text-sm text-gray-600">
        <summary className="cursor-pointer font-semibold text-gray-700">
          กติการางวัลและเงื่อนไขการเล่น
        </summary>
        <div className="mt-3 space-y-2">
          <p>แต่ละดาวสุ่มเลข 00–99 และแสดงผลทันทีหลังชำระ</p>
          <p>
            รางวัลเปิดตามจำนวนดาวสะสมของรอบจากรางวัลเล็กไปใหญ่
            และแต่ละรางวัลรับได้หนึ่งครั้ง
          </p>
          <ul className="list-inside list-disc space-y-1">
            {rooms.map((room) => (
              <li key={`rules-${room.id}`}>
                {room.name}: เปิดรางวัลที่{' '}
                {(room.milestones || []).join(', ') || '-'} ดาว
              </li>
            ))}
          </ul>
        </div>
      </details>
    </div>
  );
}
